import { api } from "./apiClient";

export const ncrAPI = {
    listByProject: (projectId) => api.get(`/projects/${projectId}/ncrs`),

    create: (projectId, payload) =>
        api.post(`/projects/${projectId}/ncrs`, payload),

    update: (projectId, ncrId, payload) =>
        api.patch(`/projects/${projectId}/ncrs/${ncrId}`, payload),

    getOne: (projectId, ncrId) =>
        api.get(`/projects/${projectId}/ncrs/${ncrId}`),

    reportPdf: (projectId, ncrId, download = false) =>
        api.get(`/projects/${projectId}/ncrs/${ncrId}/report.pdf`, {
            params: { download },
            responseType: "blob",
        }),

    actions: (projectId, ncrId) =>
        api.get(`/projects/${projectId}/ncrs/${ncrId}/actions`),

    assign: (projectId, ncrId, payload) =>
        api.post(`/projects/${projectId}/ncrs/${ncrId}/assign`, payload),

    respond: (projectId, ncrId, payload) =>
        api.post(`/projects/${projectId}/ncrs/${ncrId}/respond`, payload),

    review: (projectId, ncrId) =>
        api.post(`/projects/${projectId}/ncrs/${ncrId}/review`),

    close: (projectId, ncrId, payload) =>
        api.post(`/projects/${projectId}/ncrs/${ncrId}/close`, payload),

    reject: (projectId, ncrId, payload) =>
        api.post(`/projects/${projectId}/ncrs/${ncrId}/reject`, payload),

    resubmit: (projectId, ncrId, payload) =>
        api.post(`/projects/${projectId}/ncrs/${ncrId}/resubmit`, payload),

    escalationTargets: (projectId, ncrId) =>
        api.get(`/projects/${projectId}/ncrs/${ncrId}/escalation-targets`),

    escalations: (projectId, ncrId) =>
        api.get(`/projects/${projectId}/ncrs/${ncrId}/escalations`),

    escalationInbox: (projectId) =>
        api.get(`/projects/${projectId}/ncr-escalation-inbox`),

    escalate: (projectId, ncrId, payload) =>
        api.post(`/projects/${projectId}/ncrs/${ncrId}/escalations`, payload),

    forwardEscalation: (projectId, escalationId, payload) =>
        api.post(`/projects/${projectId}/ncr-escalations/${escalationId}/forward`, payload),

    answerEscalation: (projectId, escalationId, payload) =>
        api.patch(`/projects/${projectId}/ncr-escalations/${escalationId}/answer`, payload),
};
